import { Link, useParams } from "react-router";
import { TopicRenderer } from "../../../components/study/TopicRenderer";
import { getTopicBySlug } from "../../../data/study/topics";

export function LerenTopicPage() {
  const { slug } = useParams<{ slug: string }>();
  const topic = slug ? getTopicBySlug(slug) : undefined;

  if (!topic) {
    return (
      <main className="flex-1 mx-auto w-full max-w-3xl px-5 sm:px-6 py-8 sm:py-12 space-y-3">
        <h1 className="text-2xl font-semibold tracking-tight">Hoofdstuk niet gevonden</h1>
        <p className="text-sm text-[var(--ink-muted)] font-serif-italic">
          {slug ? `Onbekend hoofdstuk: ${slug}.` : "Geen hoofdstuk opgegeven."}
        </p>
        <Link
          to="/spreken/leren"
          className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
        >
          <span aria-hidden>←</span>
          <span>Alle hoofdstukken</span>
        </Link>
      </main>
    );
  }

  return (
    <main className="flex-1 mx-auto w-full max-w-3xl lg:max-w-4xl px-5 sm:px-6 py-8 sm:py-12 space-y-8">
      <Link
        to="/spreken/leren"
        className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
      >
        <span aria-hidden>←</span>
        <span>Alle hoofdstukken</span>
      </Link>
      <TopicRenderer topic={topic} />
      <footer className="pt-8 border-t border-[var(--border)]">
        <Link
          to="/spreken/leren"
          className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
        >
          <span aria-hidden>←</span>
          <span>Terug naar de hoofdstukken</span>
        </Link>
      </footer>
    </main>
  );
}
